export const apiUrl = "https://api.gopherrun.com";
// export const apiUrl = "https://c2f3-182-176-110-198.ngrok-free.app";

export const s3Url = "https://gopher-backend.s3.us-east-2.amazonaws.com";
// live 0
export const imageUrl = (url) => {
  const result = url?.indexOf("http");
  const imageRenderUrl = result == -1 ? `${s3Url}/${url}` : url;
  return imageRenderUrl;
};
export const mediaUrl = (url) => `${s3Url}/${url}`;

export const BaseURL = (link) => {
  return `${apiUrl}/api/v1/${link}`;
};
